import { createContext, RefObject } from "react";

/**
 * Context to share dropdown state and refs between subcomponents.
 */
export interface DropdownContextProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    triggerRef: RefObject<HTMLElement | null>;
}

export const DropdownContext = createContext<DropdownContextProps | undefined>(
    undefined
);
